import { apiHelper, API_ENDPOINTS } from "./api";
import axios from "axios";
import useUserStore from "../stores/userStore";

export const authService = {
  // Login user
  login: async (email, password) => {
    try {
      const response = await apiHelper.authPost(API_ENDPOINTS.LOGIN, {
        email,
        password,
      });

      if (response.token) {
        localStorage.setItem("authToken", response.token);
        localStorage.setItem("user", JSON.stringify(response.user));
      }

      return response;
    } catch (error) {
      throw error;
    }
  },

  // Signup user
  signup: async (userData) => {
    try {
      const response = await apiHelper.authPost(API_ENDPOINTS.SIGNUP, userData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Verify OTP
  verifyOTP: async (email, otp) => {
    try {
      const response = await apiHelper.authPost(API_ENDPOINTS.VERIFY_OTP, {
        email,
        otp,
      });

      if (response.token) {
        localStorage.setItem("authToken", response.token);
        localStorage.setItem("user", JSON.stringify(response.user));
      }

      return response;
    } catch (error) {
      throw error;
    }
  },

  // Logout user
  logout: async () => {
    try {
      await apiHelper.post(API_ENDPOINTS.LOGOUT);
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      return { success: true };
    } catch (error) {
      // Even if API call fails, clear local storage
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      throw error;
    }
  },

  // Refresh token
  refreshToken: async () => {
    try {
      const response = await apiHelper.authPost(API_ENDPOINTS.REFRESH_TOKEN);
      if (response.token) {
        localStorage.setItem("authToken", response.token);
      }
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get current user
  getCurrentUser: () => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } catch (error) {
      return null;
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem("authToken");
    return !!token;
  },

  // Get auth token
  getToken: () => {
    return localStorage.getItem("authToken");
  },
};

const sendVerificationEmail = async (email) => {
  try {
    const response = await apiHelper.authPost("/send-otp", {
      email,
      env: process.env.REACT_APP_ENV_TYPE || "prod",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const verifyOtpDirect = async (email, otp) => {
  try {
    const response = await apiHelper.authPost(
      "/verify-otp",
      {
        email,
        otp,
        env: process.env.REACT_APP_ENV_TYPE || "prod",
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // If the response is successful, we can process it here as well
    if (response.status === "success" && response.data) {
      const { setUser, handleAuthResponse } = useUserStore.getState();
      handleAuthResponse(response);
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  ...authService,
  sendVerificationEmail,
  verifyOtpDirect,
};
